<template>
	<header id="header">
		<div class="hInner header_notice subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link :to='`/board/${board_type}`'></router-link></div>
				<div class="hLine"></div>
				<div class="hName">공지사항</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="noticeForm">
		<div class="content content_w notice_edit">
			<div class="contIn">
				<div class="popupInner">
					<!-- 게시물 작성/수정 시작 { -->
					<form ref="form_board_update" id="form_board_update" class="form_board"
						:action="`${SERVER_URL}/api/app/board`" @submit.prevent="form_board_update_submit()"
						method="post" autocomplete="off">
						<input type="hidden" name="mode" value="edit">
						<input type="hidden" v-model="board_type">
						<input type="hidden" name="checked_id">

						<table>
							<tbody>
								<tr>
									<td class="boardCols1"><label for="chk_all">공개대상</label></td>
									<td class="boardCols2">
										<label>
											<input type="checkbox" name="chk_all" class="chk_all" id="chk_all" @click="checkAll($event)"> 전체
										</label>
										<label v-for="(matching, index) in matchings" :key="index">
											<input type="checkbox" name="board_field2[]" class="chk_hospital" :value="matching?.partner?.mb_boss_id" v-model="matching.checked"
											:checked="isActive(matching?.partner?.mb_boss_id)" required=""> {{ matching?.partner?.mb_nick }}
										</label>
									</td>
								</tr>
								<tr>
									<td class="boardCols1"><label for="board_subject">제목</label></td>
									<td class="boardCols2"><input type="text" v-model="form.board_subject" id="board_subject" required="" placeholder=""></td>
								</tr>
								<tr>
									<td class="boardCols1"><label for="mb_nick">작성자</label></td>
									<td class="boardCols2"><input type="text" v-model="form.mb_nick" id="mb_nick" class="readonly" placeholder="" readonly=""></td>
								</tr>
								<tr>
									<td colspan="2" class="boardCols">
										<textarea v-model="form.board_content" id="board_content" required=""></textarea>
									</td>
								</tr>
							</tbody>
						</table>
						<ul class="notice_BtnWrap subBtn">
							<template v-if="items.mb_boss_id === globaljs.mb_boss_id">
								<li><button type="button" class="save_btn" @click="form_board_update_submit()">저장</button></li>
							</template>
							<li><button type="button" class="list_btn" @click="goto_url(`/board/${board_type}`)">목록</button></li>
						</ul>
					</form>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
import header from '../components/layout/header.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

const props = defineProps({
	type: {
		type: String,
		required: true
	},
	id: {
		type: Number,
		required: true
	},
});

const board_type = ref(props.type);
const board_id = ref(props.id);

watch(
	() => props.type,
	(newVal) => {
		board_type.value = newVal;
	}
);

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

const matchings = ref([]);

const checkAll = (event) => {
	const isChecked = event.target.checked;
	matchings.value.forEach(matching => {
		matching.checked = isChecked;
	});
};

// 각 체크박스의 상태를 변경할 때마다 이 함수가 호출되도록 설정
function updateCheckedIds() {
	const checked_id_input = document.querySelector('input[name="checked_id"]');
	const formElement = document.getElementById('form_board_update');
	
	// 체크된 체크박스의 값을 담을 배열
	const checkedValues = [];

	// 체크된 체크박스의 값을 배열에 추가
	formElement.querySelectorAll('input[type="checkbox"]').forEach((input) => {
		if (input.type === 'checkbox' && input.id !== 'chk_all' && input.checked) {
			checkedValues.push(input.value);
		}
	});

	// checked_id_input의 값을 새로 갱신
	checked_id_input.value = checkedValues.join(',');
}

watch(
	matchings,
	(newItems) => {
		const allChecked = newItems.every(matching => matching.checked);
		document.querySelector('.chk_all').checked = allChecked;
	},
	{ deep: true }
);

onMounted(async () => {
	await getMatchings();
});

const form = ref({
	board_subject: '',
	board_content: '',
	mb_nick: globaljs.mb_nick
});

const getMatchings = async (limit) => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	params.append('mb_boss_id', globaljs.mb_boss_id);
	//params.append('mb_level', globaljs.mb_level);

	let response = await axios.get(`${SERVER_URL}/api/app/matching`, { params });
console.debug(response.data.result);
	matchings.value = response.data.result.map(matching => ({
		...matching,
		checked: false
	}));
	//matchings.value = response.data.result;

	await getModels();
}

window.getMatchings = getMatchings;

const matchingArray = () => {
	const matchingData = items.value.board_field2;
	if (!matchingData) {
		return [];
	}
	return matchingData.split(',').map(matching => matching.trim());
};

const isActive = (value) => {
	return matchingArray().includes(value);
};

const items = ref([]);

const getModels = async () => {
	try {
		let response = await axios.get(`${SERVER_URL}/api/app/board/${props.id}`);
console.debug(response.data.result);
		items.value = response.data.result;

		if (items.value.mb_boss_id !== globaljs.mb_boss_id) {
			Swal.fire({
				title: '권한 없음',
				html: `<div style="word-break: keep-all;">권한이 없습니다. <br/>페이지를 이동합니다.</div>`,
				icon: 'warning',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then((result) => {
				if (result.isConfirmed) {
					setTimeout(function () {
						goto_url(`/board_view/${props.type}/${props.id}`);
					}, 100);
				}
			});
			return false;
		}

		const matchingData = items.value.board_field2;
		if (!matchingData) {
			return [];
		}

		form.value.board_subject = items.value.board_subject;
		form.value.board_content = items.value.board_content;

		matchings.value.forEach(matching => {
			matching.checked = isActive(matching?.partner?.mb_boss_id);
		});
	} catch (error) {
console.error('Error getModels:', error);
	}
}

window.getModels = getModels;

async function form_board_update_submit() {
	await withSubmitFlag(async () => {
		/*
		const enabledInputs = document.querySelectorAll("input[type='checkbox'].chk_hospital:checked");
		// enabledInputs의 길이를 카운팅합니다.
		const count = enabledInputs.length;
		if (count < 1) {
			commonjs.formSwal('필수 선택', '공개대상을 하나 이상 선택해주세요.', '.chk_hospital', 'self');
			return false;
		}
		*/
		const isAnyChecked = matchings.value.some(item => item.checked);
		if (!isAnyChecked) {
			commonjs.formSwal('필수 선택', '공개대상을 하나 이상 선택해주세요.', '#chk_all', 'self');
			return false;
		}

		if (!form.value.board_subject || form.value.board_subject.trim() === '' || form.value.board_subject.trim().length < 1) {
			commonjs.formSwal(`필수 입력`, `[제목]은 필수 입력 항목입니다.`, `#board_subject`, 'self');
			return false;
		}
		if (!form.value.board_content || form.value.board_content.trim() === '' || form.value.board_content.trim().length < 1) {
			commonjs.formSwal(`필수 입력`, `[내용]은 필수 입력 항목입니다.`, `#board_content`, 'self');
			return false;
		}

		// 폼 제출 시 업데이트된 checked_id_input의 값을 사용하도록 호출
		updateCheckedIds();
		const checked_id_input = document.querySelector('input[name="checked_id"]');

		const params = new URLSearchParams();
		params.append('board_id', board_id.value);
		params.append('board_type', board_type.value);
		params.append('board_subject', form.value.board_subject);
		params.append('board_content', form.value.board_content);
		params.append('mb_boss_id', globaljs.mb_boss_id);
		params.append('checked_id', checked_id_input.value);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.put(`${SERVER_URL}/api/app/board`, params);
	console.debug(response.data.result);
			toast.fire({
				icon: "success",
				title: "공지사항을 수정했습니다."
			});
			if(opener){
				opener.location.reload();
			}
			router.push("/board/notice");
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>